export default [
  {
    value: 'JO',
    label: '+962',
  },
  {
    value: 'LY',
    label: '+218',
  },
]
